import React from 'react'
import './CorporateTwoTermsHeader.scss'

const CorporateTwoTermsHeader = () => {
    return (
        <div className='corporateTwo-terms-header'>
            <h1>Terms and Conditions</h1>
        </div>
    )
}

export default CorporateTwoTermsHeader;